const NAME = 'reservation';

export const DATE_FILTER_STATES = {
  CUSTOM: 'custom',
  TODAY: 'today',
  TOMORROW: 'tomorrow',
};

export default { NAME };
